import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {Array<import('modules/statistics/types').InterventionRatingReducer>} */
const initialState = [];

/**
 * @param {Array<import('modules/statistics/types').InterventionRatingReducer>} _
 * @param {import('modules/statistics/types').FetchInterventionRatingStatsSuccessAction} action
 * @returns {Array<import('modules/statistics/types').InterventionRatingReducer>}
 */
const updateAllData = (_, { payload }) => payload.content;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_INTERVENTION_RATING_STATS_SUCCESS]: updateAllData,
});
